import { Component, OnInit } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
    fbq?: FbqFunction;
    _fbq?: any;
  }

  interface FbqFunction {
    (...args: any[]): void;
    callMethod?: (...args: any[]) => void;
    queue?: any[];
    loaded?: boolean;
    version?: string;
    push?: any;
  }
}

@Component({
  selector: 'app-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss']
})
export class CookieConsentBannerComponent implements OnInit {
  showBanner = false;

  ngOnInit(): void {
    const consent = localStorage.getItem('cookieConsent');
    this.showBanner = consent !== 'true';

    if (consent === 'true') {
      this.loadGoogleAnalytics();
      this.loadFacebookPixel();
    }
  }

  acceptCookies(): void {
    localStorage.setItem('cookieConsent', 'true');
    this.showBanner = false;

    this.loadGoogleAnalytics();
    this.loadFacebookPixel();
  }

  declineCookies(): void {
    localStorage.setItem('cookieConsent', 'false');
    this.showBanner = false;
  }

  private loadGoogleAnalytics(): void {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-M4TDVWST4E'; // <- saját GA ID
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) { (window.dataLayer as any).push(args); }
    gtag('js', new Date());
    gtag('config', 'G-M4TDVWST4E');
  }

  private loadFacebookPixel(): void {
    // Ha már létezik, ne inicializáljuk újra
    if (window.fbq) {
      console.log('Facebook Pixel már betöltve.');
      return;
    }

    // Létrehozzuk a Pixel scriptet
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    // Inicializálás
    window.fbq = function (...args: any[]) {
      (window.fbq!.queue = window.fbq!.queue || []).push(args);
    };
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];

    // Beállítás és esemény követés
    window.fbq('init', '788074573993536'); // <- ide írd be a saját Pixel ID-t
    window.fbq('track', 'PageView');

    console.log('✅ Facebook Pixel betöltve');
  }

  /*
  <!-- Meta Pixel Code -->
    <script>
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '788074573993536');
    fbq('track', 'PageView');
    </script>
    <noscript><img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=788074573993536&ev=PageView&noscript=1"
    /></noscript>
    <!-- End Meta Pixel Code -->
   */
}
